"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Form = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactstrap = require("reactstrap");
var _reactI18next = require("react-i18next");
var _state = require("../../../state");
var _form = require("../form");
var _ui = require("../../ui");
var _excluded = ["onSubmit", "submitLoading", "children", "control", "termsOfUseUrl", "privacyPolicyUrl"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Form = function Form(_ref) {
  var onSubmit = _ref.onSubmit,
    submitLoading = _ref.submitLoading,
    children = _ref.children,
    control = _ref.control,
    termsOfUseUrl = _ref.termsOfUseUrl,
    privacyPolicyUrl = _ref.privacyPolicyUrl,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useUser = (0, _state.useUser)(),
    user = _useUser.user,
    loading = _useUser.loading;
  if (loading || !user) return /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex justify-content-center align-items-center flex-grow-1"
  }, /*#__PURE__*/_react.default.createElement(_ui.Spinner, {
    color: "primary"
  }));
  var _useTranslation = (0, _reactI18next.useTranslation)(['libCommon', 'libAuth']),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_reactstrap.Form, _extends({
    onSubmit: onSubmit
  }, props, {
    noValidate: true
  }), children, /*#__PURE__*/_react.default.createElement(_form.TermsFields, {
    control: control,
    termsOfUseUrl: termsOfUseUrl,
    privacyPolicyUrl: privacyPolicyUrl
  }), /*#__PURE__*/_react.default.createElement(_form.FormButton, {
    loading: submitLoading,
    color: "secondary"
  }, t('libCommon:submit')));
};
exports.Form = Form;